

















































import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
import { Picker, Popup } from 'vant';
import { share } from '../api';

Vue.use(Picker).use(Popup);
@Component({
  components: {
    VoteList,
  },
})
export default class Home extends Vue {
  showPicker = false;
  rankCondition = '人气作品';
  columns = ['人气作品', '最新作品'];
  active = 0;
  tempValue = '';
  searchWords: string = '';
  tabs = [
    {
      id: 3,
      default:
        'https://image2.cqcb.com/d/file/topics/activity/2020-12-21/VJZBqpgm-1608535098046.png',
      desc:
        '广大未成年人与家人一起体验喜气洋洋过春节的传统习俗活动，通过拍摄照片记录百姓喜笑颜开过新春的热闹景象，展现新时代城市和乡村日新月异的发展变化，表达爱党爱国爱社会主义之情。',
    },
    {
      id: 1,
      default:
        'https://image2.cqcb.com/d/file/topics/activity/2020-12-21/K9psMz3F-1608535098120.png',
      desc:
        '广大未成年人在春节期间参与清洁卫生、氛围布置（贴春联、挂年画、挂灯笼等）、厨艺烹饪等家庭劳动，通过新年劳动进一步了解腊八熬粥、小年大扫除、除夕做年夜饭、元宵包汤圆等辞旧迎新的传统习俗，从而在家庭劳动中培养劳动意识，感受新春氛围，传承中华民族优秀传统文化。',
    },
    {
      id: 2,
      default:
        'https://image2.cqcb.com/d/file/topics/activity/2020-12-21/jBgYGAtD-1608535098194.png',
      desc:
        '广大未成年人为亲朋好友、老师等送上手写祝福，表达新春祝福及感恩感激之情；用毛笔书写“福”字和春联，送给邻居好友，分享喜迎牛年春节之情。',
    },
  ];

  get tabClass() {
    return `tab-item-active` + (this.active + 1);
  }
  get type() {
    return this.tabs[this.active].id;
  }
  created() {
    share(this);
  }
  handleClickTab(index: number) {
    this.tempValue = '';
    this.searchWords = '';
    this.active = index;
    this.rankCondition = '人气作品';
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
    // this.searchWords = (this.$refs.input as HTMLInputElement).value;
  }
  enterDetailPage(id: number) {
    this.$router.push({
      path: 'detail',
      query: {
        id: String(id),
        type: String(this.active + 1),
      },
    });
  }
  onConfirm(e: any) {
    this.rankCondition = e;
    this.showPicker = false;
  }
  jumpToUserCenter() {
    this.$router.push({
      path: 'user',
    });
  }
}
